import Load from 'components/Load';
import PrivateRoute from 'components/PrivateRoute';
import React from 'react';
import basePath from 'utils/basePath';

export interface PersonalizedOfferRoutesParams {
  id: string;
}

const AsyncCreatePoContainer = Load(
  () => import(/* webpackChunkName: "host-po" */ './CreatePoContainer'),
  {},
  true,
);
const AsyncNewPoContainer = Load(
  () => import(/* webpackChunkName: "host-po" */ './NewPoContainer'),
  {},
  true,
);
const AsyncUpdatePoContainer = Load(
  () => import(/* webpackChunkName: "host-po" */ './UpdatePoContainer'),
  {},
  true,
);

const PersonalizedOfferRoutes = [
  <PrivateRoute
    key="newoffer"
    path={`${basePath}/new-personalized-offer/:id`}
    component={AsyncNewPoContainer}
  />,
  <PrivateRoute
    key="createoffer"
    path={`${basePath}/create-personalized-offer/:id`}
    component={AsyncCreatePoContainer}
  />,
  <PrivateRoute
    key="updateoffer"
    path={`${basePath}/update-personalized-offer/:id`}
    component={AsyncUpdatePoContainer}
  />,
];

export default PersonalizedOfferRoutes;
